import { ApiProperty } from '@nestjs/swagger';
import { IsEmail, IsNotEmpty, IsOptional, ValidateIf } from 'class-validator';
import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { Attendance } from '../attendance/attendance.entity';
import { CostCenters} from '../cost-centers/cost-centers.entity';
import {EmploymentModeEnum,EmployeeTerminationApprovalStatus,RolesList,Gender,MaritalStatus} from '@gtpl/shared-models/gtpl';
import { Projects } from '../projects/projects.entity';
import { UserEntity } from '../user/user.entity';
import { ProjectMapping } from '../project-mapping/project-mapping.entity';
import { Designations } from '../designations/designations.entity';
import { EmployeeCashbook } from '../employee-cashbook/employee-cashbook.entity';
@Entity('employee_details')
export class EmployeeDetails {
  
  @PrimaryGeneratedColumn("increment",{name:'id'})
  Id:number;
  @Column("int",{
    nullable: true,
    name:"cost_center_id"
    })
  costcenterId:number;
  @Column("int",{
    nullable: true,
    name:"project_id"
    })
  projectId:number;
  @Column("int",{
    nullable: true,
    name:"subcontractor_id"
    })
  subContractorId:number;
  @Column("varchar",{
    nullable: false,
    length:12,
    name:"adhar_number"
    })
  @Index({unique:true})
  empCode:string;
  @Column("varchar",{
    length:50,
    name:"emp_name"
    })
  empName:string;
  @Column("varchar",{
    nullable: true,
    length:20,
    name:"mobile_no"
    })
    mobileNo:string;
  @Column("varchar",{
      nullable: true,
      length:40,
      name:"email_id"
  })
  emailId:string;
@Column('varchar',{
    // type:'enum',
    nullable: false,
    // enum:Gender,
    // default:Gender.Male,
    length:10,
    name:"gender"
})
Gender:string;
@Column('varchar',{
  // type:'enum',
  nullable: false,
  length:10,
  // enum:MaritalStatus,
  // default:MaritalStatus.Married,
  name:"marital_status"
})
maritalStatus:string;
  @Column('varchar',{
    // type: 'enum',
    length:15,
    nullable: false,
    // enum : EmploymentModeEnum,
    // default:EmploymentModeEnum.Direct,
    name: 'employment_mode'
  })
  employmentMode: string;  
  @Column({
      type:'enum',
      // length:5,
      nullable: true,
      enum:RolesList,
      default:RolesList.LONE,
      name:"role"
      })
  Role:RolesList;
  @Column("boolean",{
    default:true,
    name:"ot_applicable"
    })
  otApplicable:boolean;
  @Column("boolean",{
    default:true,
    name:"status"
    })
  status:boolean;
  @Column("boolean",{
    default:true,
    name:"is_terminated"
    })
  isTerminated:boolean;
  @Column("boolean", {
    default:false,
    name: "is_termination_approved" 
  })
  isTerminationApproved: boolean;
  @Column("int", {
      nullable: true,
      name: "termination_approved_by"
  })
  terminationApprovedBy: number;
  
  @Column("int",{
    nullable: true,
    name:"designation_id"
    })
  designationId:number;
  
  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("int", {
      nullable: true,
      name: "created_user"
  })
  createdUser: number | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("int", {
      nullable: true,
      name: "updated_user"
  })
  updatedUser: number | null;
  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;
  // @OneToMany(type => Attendance, attendance => attendance.empInfo,{cascade: true})
  // @JoinColumn({ name: 'id' })
  // attendanceInfo: [Attendance];
  @OneToMany(type=>Attendance, attendance=>attendance.empInfo,{cascade: true})
  attendanceInfo:Attendance[];
  @OneToMany(type=>ProjectMapping, projectMapping=>projectMapping.empId,{cascade: true})
  projectMappingInfo:ProjectMapping[];
  @OneToMany(type=>EmployeeCashbook, cashbook=>cashbook.empId,{cascade:true})
  cashbook:EmployeeCashbook[];
  @OneToOne(() => CostCenters, costCenters => costCenters.costCenterId) 
  // specify inverse side as a second parameter
  costCenters: CostCenters;
  
  @OneToOne(() => Projects, projects => projects.projectId) 
  // specify inverse side as a second parameter
  projects: Projects;
  @OneToOne(() => Designations, designations => designations.designationId) 
  // specify inverse side as a second parameter
  designations: Designations;
  @OneToOne(() => UserEntity, userEntity => userEntity.id) 
  // specify inverse side as a second parameter
  userEntity: UserEntity;
}
